import {Component, Vue} from 'vue-property-decorator'

@Component
class IsParticipantsLimited extends Vue {
	participantsGroupIds() {
		const params = this.$store.getters['events/selectedEventViewParam']('participants', null);
        return params?.groupIds || this.$store.state.session.profile?.groupIds || [];
	}
}

export default IsParticipantsLimited;